import React, { useEffect, useState } from 'react'
import { withRouter } from 'react-router-dom'

import {
  Grid,
  Box,
  InputAdornment,
  TextField as Input,
  CircularProgress,
  Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TableSortLabel
} from '@material-ui/core'

import Widget from '../../components/Widget/Widget'
import { Typography } from '../../components/Wrappers/Wrappers'

import useStyles from "./styles";
// import moment from 'moment'

//context
import {
  useUsersState,
  getUsersRequest,
  updateUserStatus,
} from "../../context/UsersContext";

// Icons
import {
  Search as SearchIcon
} from '@material-ui/icons'

import config from "../../config";

//Function to sort data
function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1
  }
  if (b[orderBy] > a[orderBy]) {
    return 1
  }
  return 0
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy)
}

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index])
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0])
    if (order !== 0) return order
    return a[1] - b[1]
  })
  return stabilizedThis.map(el => el[0])
}

//Table headings
const headCells = [
  { numeric: true, disablePadding: false, label: '#', sort: false, center: false },
  { id: "name", numeric: false, disablePadding: false, label: "NAME", sort: true, center: true },
  { id: "email", numeric: false, disablePadding: false, label: "EMAIL", sort: true, center: true },
  { id: "description", numeric: false, disablePadding: false, label: "DESCRIPTION", sort: true, center: true },
  { id: "date", numeric: true, disablePadding: false, label: "DATE", sort: true, center: true },
];

//It will create table heading
function EnhancedTableHead(props) {
  const {
    order,
    orderBy,
    onRequestSort,
  } = props
  const createSortHandler = property => event => {
    onRequestSort(event, property)
  }

  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell, index) => (
          <TableCell
            width={headCell.width}
            key={index}
            align={headCell.center ? 'center' : headCell.numeric ? 'left' : 'right'}
            padding={headCell.disablePadding ? 'none' : 'normal'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            {headCell.sort ?
              <TableSortLabel
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : 'asc'}
                onClick={createSortHandler(headCell.id)}
              >
                <Typography
                  noWrap
                  weight={'medium'}
                  variant={'body2'}
                >
                  {headCell.label}
                </Typography>
              </TableSortLabel>
              :
              <Typography
                noWrap
                weight={'medium'}
                variant={'body2'}
              >
                {headCell.label}
              </Typography>
            }
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  )
}

//Users component
const ContactUs = () => {

  const classes = useStyles();
  // const context = useUsersState();


  //  var [users, setBackUsers] = useState();


  const [order, setOrder] = useState('desc')
  const [orderBy, setOrderBy] = useState('created_date')
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(5)
  // const [userRows, setUsersRows] = useState(context.users.users)
  // const [searchVal, setSearchVal] = useState('');

  //React hook which calls when page loads
  // useEffect(() => {
  //   getUsersRequest(context.setUsers);

  // }, []); // eslint-disable-line


  //React hook which calls when context value change
  // useEffect(() => {
  //   setBackUsers(context.users.users);
  //   setUsersRows(context.users.users);
  //   if (searchVal !== '') {
  //     const newArr = context.users.users.data.filter(c => {
  //       return c.first_name && c.last_name && (c.first_name.toLowerCase().includes(searchVal.toLowerCase()) || c.first_name.toLowerCase().includes(searchVal.toLowerCase()) || c.gender.toLowerCase().includes(searchVal.toLowerCase()))
  //     })
  //     setBackUsers({ isLoaded: true, data: newArr })
  //   }
  // }, [context]);

  //Function to store Sort by and property to sort
  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc'
    setOrder(isAsc ? 'desc' : 'asc')
    setOrderBy(property)
  }

  //Function to call when pagination value change
  const handleChangePage = (event, newPage) => {
    setPage(newPage)
  }

  //Function to set value of rows per page
  const handleChangeRowsPerPage = event => {
    setRowsPerPage(parseInt(event.target.value, 10))
    setPage(0)
  }
  // ("user row", userRows)


  //Function to search
  // const handleSearch = e => {
  //   let value = e.currentTarget.value.replace(/^\s+/, "")
  //   // setSearchVal(value)
  //   setPage(0)
  //   const newArr = userRows.data.filter(c => {
  //     return c.first_name && c.last_name && (c.last_name.toLowerCase().includes(value.toLowerCase()) || c.first_name.toLowerCase().includes(value.toLowerCase()) || c.gender.toLowerCase().includes(value.toLowerCase()))
  //   })
  //   setBackUsers({ isLoaded: true, data: newArr })
  // }


  // // Function call to ban/unban user
  // const handleChange = async (event, user_id) => {
  //   await updateUserStatus(context.setUsers, {
  //     is_active: event.target.checked ? true : false,
  //     user_id: user_id
  //   });
  //   await getUsersRequest(context.setUsers);
  // };


  // //Function call to redirect to user details screen
  // const redirectToDetails = async (user_id) => {
  //   props.history.push({
  //     pathname: process.env.PUBLIC_URL + '/app/users/details',
  //     state: { user_id: user_id }
  //   })
  // }

  return (
    <Grid container spacing={3}>
      <span className={classes.mainPageTitle}>Contact Us</span>
      <Grid item xs={12}>
        <Widget inheritHeight>
          <Box
            justifyContent={'space-between'}
            display={'flex'}
            alignItems={'center'}
          >
            <Box
              display={'flex'}
              flexDirection={'column'}
              alignItems={'flex-end'}
            >
              <Input
                id="search-field"
                // label="Search"
                margin="dense"
                variant="outlined"
                // onChange={(e) => handleSearch(e)}
                // value={searchVal}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon />
                    </InputAdornment>
                  ),
                }}
              />
            </Box>
          </Box>
        </Widget>
      </Grid>
      {/* {!context.users.isLoaded || !users.data ? (
        <Box
          display={"flex"}
          justifyContent={"center"}
          alignItems={"center"}
          width={"100vw"}
          height={"calc(100vh - 200px)"}
        >
          <CircularProgress size={50} />
        </Box> */}
      {/* ) : ( */}
      <Grid item xs={12}>
        <Paper className={classes.root}>
          <TableContainer className={classes.container}>
            <Table
              aria-labelledby="tableTitle"
              aria-label="enhanced table">

              <EnhancedTableHead
                order={order}
                orderBy={orderBy}
                onRequestSort={handleRequestSort}
              // rowCount={users.data.length}
              />


              <TableBody>
                {/* {stableSort(users.data, getComparator(order, orderBy))
                      .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => {
                        return ( */}
                <TableRow

                  hover
                  tabIndex={-1}
                  // key={index}
                  style={{ cursor: 'pointer' }}>

                  <TableCell
                    component="th"
                    scope="row"
                  // onClick={() => redirectToDetails(row.id)}
                  >
                    <Typography variant={'body2'}>
                      1 {/* {(page * rowsPerPage) + index + 1} */}
                    </Typography>
                  </TableCell>

                  <TableCell align={'center'}
                  //  onClick={() => redirectToDetails(row.id)}
                  >
                    Name</TableCell>


                  <TableCell align={'center'}
                  //  onClick={() => redirectToDetails(row.id)}
                  >email</TableCell>

                  <TableCell align={'center'}
                  // onClick={() => redirectToDetails(row.id)}
                  >DESCRIPTION</TableCell>

                  <TableCell align={'center'}
                  // onClick={() => redirectToDetails(row.id)}
                  > 25/05/2022
                    {/* {moment(row.created_on).format("DD-MM-YYYY hh:mm:ss A")} */}
                  </TableCell>
                </TableRow>
                {/*  ); */}
                {/* })} */}
              </TableBody>

              {/* <TableBody>
                    <TableRow>
                      <TableCell colSpan={headCells.length}>
                        <Typography
                          style={{ textAlign: 'center', padding: '10px 0px' }}
                          noWrap
                          variant={'h4'}>No Records</Typography>
                      </TableCell>
                    </TableRow>
                  </TableBody> */}

            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={config.defaultRowsPerPage}
            component="div"
            // count={users.data.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Paper>
      </Grid>

    </Grid>
  )
}

export default withRouter(ContactUs);
